import React from 'react';
export const Features = () => {
  const features = [{
    icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vXB3qrBt4saY89B15EYYic/Tracked_Goals_and_Action_Steps.png" alt="" className="w-20 h-20" data-id="element-55" />,
    title: 'Track Goals and Action Steps',
    description: 'Upload notes and generate meaningful action steps instantly'
  }, {
    icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1cAexsurBdFeT48HyxGqbZ/Personalized_Podcasts.png" alt="" className="w-20 h-20" data-id="element-56" />,
    title: 'Personalized Podcasts',
    description: "Send custom podcast episodes aligned with each teacher's goals"
  }, {
    icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/huUVuDvF2GVjJFxWL8hAjk/Efficient_Prep.png" alt="" className="w-20 h-20" data-id="element-57" />,
    title: 'Efficient Prep',
    description: 'Review coaching cycles and prep for 1:1s in seconds'
  }, {
    icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/45utZfsySM12qsuZ2RqBDr/Cognitive_Support.png" alt="" className="w-20 h-20" data-id="element-58" />,
    title: 'Cognitive Support',
    description: 'Stay grounded in pedagogy while reducing mental load'
  }, {
    icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vqZUMoHwViZ5UvDxafnF7e/Smart_Reminders.png" alt="" className="w-20 h-20" data-id="element-59" />,
    title: 'Smart Reminders',
    description: 'Send timely reminders and encouragement to maintain momentum',
    comingSoon: true
  }];
  return <section id="features" className="w-full py-section-mobile md:py-section-desktop bg-white relative overflow-hidden" data-id="element-60">
      <div className="container mx-auto px-4 sm:px-6" data-id="element-61">
        <div className="flex flex-col md:flex-row items-center justify-center max-w-4xl mx-auto mb-12 md:mb-20" data-id="element-62">
          <div className="flex items-center gap-0 md:gap-4" data-id="element-63">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tgogRyhacp8wRnoA9dF3J4/Nisa_-_Plant_Arc_Growth.png" alt="Plant growth illustration" className="w-full max-w-[150px]" data-id="element-64" />
            <h2 className="pt-5 text-h2-mobile md:text-h2-desktop font-serif font-normal text-teal-950 leading-tight" data-id="element-65">
              Nisa is a coach's second brain
            </h2>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-7xl lg:max-w-[80%] mx-auto" data-id="element-66">
          {features.map((feature, index) => {
          // Array of background colors for cards
          const bgColors = ['bg-orange-100 hover:bg-orange-50', 'bg-amber-100 hover:bg-amber-50', 'bg-red-100 hover:bg-red-50', 'bg-purple-100 hover:bg-purple-50', 'bg-gray-100 hover:bg-gray-50'];
          return <div key={index} className={`group relative ${bgColors[index]} rounded-2xl p-8 shadow-glow hover:shadow-glow-hover transition-all duration-500 hover:-translate-y-1 border-2 border-gray-100`} data-id="element-67">
                <div className="relative" data-id="element-68">
                  <div className="mb-6 group-hover:scale-110 transition-transform duration-500" data-id="element-69">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-70">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-71">{feature.description}</p>
                  {feature.comingSoon && <span className="absolute top-4 right-4 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-400/80 text-white" data-id="element-72">
                      Coming Soon
                    </span>}
                </div>
              </div>;
        })}
        </div>
        <div className="mt-20 max-w-2xl mx-auto text-center" data-id="element-73"></div>
      </div>
    </section>;
};